import classNames from 'classnames';
import styles from './FormfieldGroup.module.scss';
import { ErrorMessage } from 'ui/components';
import { RegisterOptions } from 'react-hook-form';

type State = {
	required?: boolean;
	disabled?: boolean;
	hasError?: boolean;
};

export interface FormfieldGroupProps {
	className?: string;
	id: string;
	name: string;
	label: string;
	children: React.ReactNode;
	register?: (name: string, options?: RegisterOptions) => void;
	errorMessage?: string;
	state?: State;
}

const ariaError = (state: State, name: string, id: string) => {
	if (state?.['hasError']) return name + id;
};

export const FormfieldGroup: React.FC<FormfieldGroupProps> = ({ className, id, name, label, register, errorMessage, state, children }) => {
	const { required, disabled, hasError } = state ?? {};
	return (
		<fieldset
			name={name}
			className={classNames(styles.FormfieldGroup, className, { [styles.hasError]: hasError }, { [styles.isDisabled]: disabled })}
			{...(register ? register(name, { required }) : {})}
			aria-describedby={ariaError(state, name, id)}
		>
			<legend id={id} className={classNames(styles.FormLabel, styles.FormfieldGroup_label)}>
				{label}
				{required && (
					<span className={styles.FormLabel___required} aria-hidden="true">
						*
					</span>
				)}
			</legend>
			{children}
			{hasError && <ErrorMessage id={name + id}>{errorMessage}</ErrorMessage>}
		</fieldset>
	);
};
